
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetoshirdiurbania() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Urbania On Rent ',
        heading: 'Amruta Travels: Pune to Shirdi Urbania On Rent ',
        headingDescription: 'Amruta Travels offers Pune to Shirdi Urbania on Rent, providing a luxurious and comfortable travel solution for your pilgrimage or group outing. Our Force Urbania vans are perfect for small to medium-sized groups looking for a safe, smooth, and hassle-free journey from Pune to the sacred town of Shirdi. Whether it is a family trip, spiritual tour, or corporate group visit, we ensure top-notch travel comfort and reliability.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


   "services": [
    {
      "name": "Pune to Shirdi Urbania on Rent Near Me",
      "description": "Looking for a Force Urbania to travel from Pune to Shirdi? Amruta Travels offers reliable, comfortable, and affordable Urbania rentals for your pilgrimage journey. With AC, spacious interiors, and a professional driver, enjoy a smooth and safe ride to Shirdi."
    },
    {
      "name": "Pune to Shirdi Urbania Package",
      "description": "Amruta Travels offers all-inclusive Urbania packages for a seamless trip from Pune to Shirdi. Enjoy luxury travel with comfortable seating, AC, and a knowledgeable driver. Our package includes round-trip services with flexible timings."
    },
    {
      "name": "Pune Airport to Shirdi Urbania On Rent",
      "description": "Need a pickup from Pune Airport to Shirdi? Rent a Force Urbania from Amruta Travels for a stress-free journey. We offer comfortable and reliable transport from Pune Airport to Shirdi with experienced drivers and AC-equipped vehicles."
    },
    {
      "name": "Pune to Ajanta Ellora Urbania on Rent",
      "description": "Travel in style and comfort from Pune to Ajanta Ellora with Amruta Travels' Force Urbania rentals. Our 13- and 17-seater vehicles are perfect for long trips, providing ample space, AC comfort, and a smooth journey to these historical caves."
    },
    {
      "name": "Pune to Aurangabad Urbania On Rent",
      "description": "Book a Force Urbania with Amruta Travels for your Pune to Aurangabad journey. Our 13- and 17-seater Urbania vehicles ensure a comfortable trip to Aurangabad, whether you're visiting the Ellora caves or other tourist attractions."
    },
    {
      "name": "Pune to Nashik Urbania on Rent",
      "description": "Amruta Travels provides comfortable Force Urbania rentals for travel from Pune to Nashik. Perfect for groups or family trips, our Urbania vehicles offer AC, spacious interiors, and expert drivers to make your journey to Nashik enjoyable."
    },
    {
      "name": "Pune to Bhimashankar Urbania On Rent",
      "description": "Travel from Pune to Bhimashankar in luxury with Amruta Travels' Force Urbania rentals. Perfect for spiritual trips, our 13- and 17-seater Urbania vans offer spacious interiors, AC, and safe transport to the famous Bhimashankar temple."
    },
    {
      "name": "Pune to Trimbakeshwar Urbania on Rent",
      "description": "For a comfortable and luxurious ride to Trimbakeshwar from Pune, book a Force Urbania with Amruta Travels. Our vehicles are designed for comfort with AC, pushback seats, and plenty of space for your group, ensuring a smooth journey to this sacred destination."
    },
    {
      "name": "Pune to Grishneshwar Urbania on Rent",
      "description": "Amruta Travels offers Force Urbania rentals for travel from Pune to Grishneshwar, ensuring comfort and safety for your pilgrimage. Our spacious and air-conditioned vans are ideal for group travel with experienced drivers and a stress-free experience."
    },
    {
      "name": "Pune to Ahmednagar Urbania on Rent",
      "description": "Book a Force Urbania with Amruta Travels for a trip from Pune to Ahmednagar. Whether for religious tours or family outings, our 13- and 17-seater vehicles ensure a comfortable ride with air conditioning and ample space."
    },
    {
      "name": "Pune to Nagpur Urbania on Rent",
      "description": "For long-distance travel from Pune to Nagpur, rent a Force Urbania from Amruta Travels. With 13- and 17-seater options available, enjoy a smooth journey with AC comfort, spacious seating, and expert drivers who know the best routes."
    },
    {
      "name": "Pune to Shani Shingnapur Urbania Hire",
      "description": "Amruta Travels offers Force Urbania rentals for trips from Pune to Shani Shingnapur. Perfect for religious tours, our 13- and 17-seater Urbania vans offer a comfortable and convenient way to visit this famous temple, with a professional driver at your service."
    },
    {
      "name": "Pune to Shirdi Urbania Package",
      "description": "Choose Amruta Travels for an all-inclusive Urbania package for your trip from Pune to Shirdi. We provide well-maintained, air-conditioned vehicles with experienced drivers, ensuring a smooth and comfortable journey to the Sai Baba temple."
    },
    {
      "name": "13 Seater Pune to Shirdi Urbania Hire",
      "description": "Book a 13-seater Force Urbania with Amruta Travels for your Pune to Shirdi trip. Ideal for small groups, our vehicles provide luxury travel with ample seating, AC, and a professional driver to ensure a safe and comfortable ride."
    },
    {
      "name": "17 Seater Pune to Shirdi Urbania Hire",
      "description": "Rent a 17-seater Force Urbania from Amruta Travels for your group trip from Pune to Shirdi. Our Urbania vehicles offer superior comfort with air conditioning, spacious interiors, and dedicated drivers for a hassle-free journey to the Sai Baba temple."
    },
    {
      "name": "Pune to Ahilyanagar Urbania on Rent",
      "description": "Amruta Travels offers Force Urbania rentals for your Pune to Ahilyanagar journey. Whether you're visiting the historic sites or on a family trip, our 13- and 17-seater Urbania vans provide the perfect blend of comfort, safety, and reliability."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Urbania on Rent Near Me", "Pune to Shirdi Urbania Package"],
    ["Pune Airport to Shirdi Urbania On Rent", "Pune to Ajanta Ellora Urbania on Rent"],
    ["Pune to Aurangabad Urbania On Rent", "Pune to Nashik Urbania on Rent"],
    ["Pune to Bhimashankar Urbania On Rent", "Pune to Trimbakeshwar Urbania on Rent"],
    ["Pune to Grishneshwar Urbania on Rent", "Pune to Ahmednagar Urbania on Rent"],
    ["Pune to Nagpur Urbania on Rent", "Pune to Shani Shingnapur Urbania Hire"],
    ["Pune to Shirdi Urbania Package", "13 Seater Pune to Shirdi Urbania Hire"],
    ["17 Seater Pune to Shirdi Urbania Hire", "Pune to Ahilyanagar Urbania on Rent"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Luxurious Urbania Rentals for Pune to Shirdi",
    "WhyChoosedescription": "Amruta Travels offers premium Urbania vans for rent, providing a luxurious and comfortable travel experience from Pune to Shirdi. With spacious interiors, plush seating, and modern amenities, our Urbania vans are the perfect choice for a smooth, enjoyable journey to one of Maharashtra’s most revered pilgrimage destinations."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimages, Family Trips, and Group Travel",
    "WhyChoosedescription": "Whether you're planning a family trip, a corporate pilgrimage, or a group outing to Shirdi, Urbania vans offer ample seating, air conditioning, and sufficient luggage space. This makes them the ideal vehicle for both short and long-distance journeys, ensuring everyone travels in comfort and style."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Shirdi Trips",
    "WhyChoosedescription": "We offer competitive and transparent pricing for Urbania van rentals for Pune to Shirdi trips. Our all-inclusive rates cover fuel, tolls, driver fees, and taxes with no hidden charges. This allows you to plan your pilgrimage with peace of mind, knowing the full cost upfront."
  },
  {
    "WhyChooseheading": "Professional Drivers for Safe and Punctual Travel",
    "WhyChoosedescription": "Our experienced drivers ensure a safe and timely journey to Shirdi from Pune. They are well-versed in the best routes, ensuring minimal delays while providing top-notch customer service along the way. You can relax and enjoy the trip, knowing that you’re in safe hands."
  },
  {
    "WhyChooseheading": "Modern Amenities for a Comfortable Ride",
    "WhyChoosedescription": "Our Urbania vans are equipped with modern amenities including air conditioning, plush seating, USB charging points, and entertainment options. With spacious interiors, these vans offer a relaxed and comfortable atmosphere for the entire group during the 4-5 hour journey from Pune to Shirdi."
  },
  {
    "WhyChooseheading": "Ideal for Long-Distance Travel with Minimal Stops",
    "WhyChoosedescription": "The Urbania vans are designed to provide a smooth, uninterrupted ride for long-distance travel, ensuring a comfortable experience from Pune to Shirdi. With ergonomic seating and a well-maintained suspension system, the journey is designed to minimize fatigue, so you can focus on the spiritual experience ahead."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Flexible Rental Options",
    "WhyChoosedescription": "Booking an Urbania van for your Pune to Shirdi trip is quick and easy with Amruta Travels. Our online platform allows you to book your van in minutes, and we offer flexible rental options for day trips or extended journeys. You can also make changes to your booking if your travel plans shift."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Journey",
    "WhyChoosedescription": "Amruta Travels provides 24/7 customer support for all bookings. Whether you need assistance with planning your route, last-minute changes, or simply have questions about the vehicle, our team is always available to ensure your Pune to Shirdi trip goes smoothly."
  }
]




















    }

const faqData = [
  {
    question: 'Can I rent a Force Urbania for a trip from Pune to Shirdi with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Force Urbania rentals for trips from Pune to Shirdi. Our Urbania minibuses are perfect for group travel, ensuring a comfortable, hassle-free journey to Shirdi.',
  },
  {
    question: 'What seating options are available for the Force Urbania on rent for Pune to Shirdi?',
    answer: 'We provide Force Urbania minibuses with seating capacities of 13 and 17 seats, ideal for small to medium-sized groups traveling from Pune to Shirdi.',
  },
  {
    question: 'Is a driver included with the Force Urbania rental for Pune to Shirdi?',
    answer: 'Yes, all Force Urbania rentals for Pune to Shirdi come with an experienced, professional driver who ensures safety, punctuality, and comfort throughout the trip.',
  },
  {
    question: 'How much does it cost to rent a Force Urbania for a Pune to Shirdi trip?',
    answer: 'The cost for renting a Force Urbania depends on factors like the seating capacity, trip duration, and services. Typically, rates start from ₹35 per km for a 13-seater and ₹38 per km for a 17-seater. For a trip to Shirdi, please contact us for a personalized quote.',
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained for the Pune to Shirdi trip?',
    answer: 'Yes, all our Force Urbania vehicles are regularly maintained and thoroughly sanitized before each trip to ensure maximum comfort and safety for your Pune to Shirdi journey.',
  },
  {
    question: 'How long does it take to travel from Pune to Shirdi in a Force Urbania?',
    answer: 'The trip from Pune to Shirdi typically takes around 5 to 6 hours, depending on traffic and route conditions. The Force Urbania provides a comfortable ride for the duration of the journey.',
  },
  {
    question: 'Can I book a Force Urbania online for a Pune to Shirdi trip?',
    answer: 'Yes, you can easily book a Force Urbania for your Pune to Shirdi trip by visiting our website or contacting us directly. We will assist you with your booking and ensure everything is arranged.',
  },
  {
    question: 'Is the Force Urbania suitable for a religious trip to Shirdi?',
    answer: 'Absolutely! The Force Urbania provides a comfortable and spacious travel experience, making it an excellent choice for groups visiting Shirdi for religious purposes or family pilgrimages.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sachin Naik',
    role: 'IT Professional, Pune',
    text: 'We rented a Force Urbania for a family trip from Pune to Shirdi. The bus was spacious, well-maintained, and the driver was courteous and professional. The entire trip was smooth and enjoyable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Seema Tiwari',
    role: 'Home Maker',
    text: 'Our trip from Pune to Shirdi in the Force Urbania was fantastic. The vehicle was comfortable, and the driver made the journey even better by being punctual and very helpful. Highly recommend Amruta Travels for group trips!',
    rating: 5,
  },
];











































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Urbania On Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-shirdi-urbania-on-rent.jpg", // Update with actual image URL
  "description": "Rent luxury 13-seater and 17-seater Force Urbania for comfortable trips from Pune to Shirdi. Amruta Travels offers affordable packages for group travel, temple tours, and more with high-end amenities.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200", // Adjust price as per service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-shirdi-urbania-on-rent"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Shirdi Urbania On Rent | Luxury Urbania Rental | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a 13-seater or 17-seater Urbania from Pune to Shirdi. Book luxury travel with comfort and style for group tours, temple visits, and more. Affordable pricing and premium service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdiurbania;